var map = {
	"./bicycle.svg": 44374,
	"./bus.svg": 52723,
	"./businesscar.svg": 87209,
	"./car.svg": 21019,
	"./excavator.svg": 67322,
	"./excavator2.svg": 31140,
	"./plain.svg": 74517,
	"./ship.svg": 5293,
	"./suv.svg": 5395,
	"./transportmixer.svg": 49385,
	"./truck.svg": 54024,
	"./van.svg": 5790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77173;